import axios from "axios";
import qs from "qs";
import { api_url } from "../config";
const base_url = api_url;

export const getRmBuddyTasks = async ({
  rmBuddyId,
  fromDate,
  toDate,
  taskType,
  warehouseId,
  status
}) => {
  return axios.get(`${base_url}/RMBuddyTask/list`, {
    params: {
      rmBuddyId,
      fromDate,
      toDate,
      taskType,
      warehouseId,
      status
    },
    withCredentials: true
  });
};

export const searchTasksByOrderNum = async ({ warehouseId, orderNumber }) => {
  return axios.get(`${base_url}/RMBuddyTask/searchByOrderNumber`, {
    params: {
      orderNumber,
      warehouseId
    },
    withCredentials: true
  });
};

export const searchTasksByServiceReqId = async ({ serviceRequestId }) => {
  return axios.get(`${base_url}/RMBuddyTask/findByServiceRequestId`, {
    params: {
      serviceRequestId
    },
    withCredentials: true
  });
};

export const markAsDone = async ({ buddyTaskId }) => {
  return axios.put(
    `${base_url}/RMBuddyTask/markAsDone`,
    {
      buddyTaskId
    },
    {
      withCredentials: true
    }
  );
};

export const getSuggestedTransferBuddies = async ({ taskId, warehouseId }) => {
  return axios.get(`${base_url}/RMBuddy/getAllocationRmBuddies`, {
    params: {
      taskId,
      warehouseId
    },
    withCredentials: true
  });
};

export const transferTask = async ({ buddyTaskId, rmBuddyId }) => {
  return axios.put(
    `${base_url}/RMBuddyTask/transfer`,
    {
      buddyTaskId,
      rmBuddyId
    },
    {
      withCredentials: true
    }
  );
};

export const canTransferTasks = async ({ buddyTaskIds, rmBuddyId }) => {
  return axios.post(
    `${base_url}/RMBuddyTask/canTransferTasks`,
    {
      buddyTaskIds,
      rmBuddyId
    },
    {
      withCredentials: true
    }
  );
};

export const getRmBuddyTaskDetails = async id => {
  return axios.get(`${base_url}/RMBuddyTask/${id}`, {
    withCredentials: true
  });
};

export const getUnallocatedTasks = async ({ warehouseId, taskType }) => {
  return axios.get(`${base_url}/RMBuddyTask/getUnallocatedTasks`, {
    params: {
      taskType,
      warehouseId
    },
    withCredentials: true
  });
};
